import React from 'react';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';
import { useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../../stores/types/types';
import Socket from '../../../connection/socket';

interface MultiAccountLoginConfirmationProps {
    socket?: Socket | null | undefined
}

export default function MultiAccountLoginConfirmation(props: MultiAccountLoginConfirmationProps) {
    const { socket } = props;
    const host = useSelector((state: GS) => state.SessionReducer.host);

    function backToHome() {
        window.location.href = host
            ? '/producer'
            : '/';
    }

    function kickOtherUser() {
        socket?.connection?.emit('kick-duplicate-user');
    }

    return (
        <MultiButtonConfirmationModal
            headerText="You're already in this greenroom"
            bodyText="Your account is already being used in this greenroom. You might have it open in another tab, or have shared your login with someone else."
            firstButtonText="Back to Home"
            firstButtonAction={backToHome}
            secondButtonText="Enter here instead"
            secondButtonAction={kickOtherUser}
            className="multi-account-login-confirmation"
            isOpen
        />
    );
}